import React from 'react';

import { Container } from '@soluto-design/react';
import Breadcrumb, { BreadcrumbProps } from '../../atoms/Breadcrumb';

export interface BreadcrumbSectionProps extends BreadcrumbProps {}

function BreadcrumbSection(props: BreadcrumbSectionProps) {
    return (
        <section className="pb-xl">
            <Container>
                <Breadcrumb {...props} />
            </Container>
        </section>
    );
}

export default BreadcrumbSection;
